"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var options = {};
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var Video = /*#__PURE__*/function (_React$Component) {
    _inherits(Video, _React$Component);

    var _super = _createSuper(Video);

    function Video(props) {
      var _this;

      _classCallCheck(this, Video);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "startVideo", function () {
        _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
          playing: true
        }));
      });

      _this.state = {
        playing: false
      };
      return _this;
    }

    _createClass(Video, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            theme = _this$props.theme,
            video = _this$props.video,
            controls = _this$props.controls;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.wrapperClass,
          onClick: this.startVideo
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.playerContainer
        }, /*#__PURE__*/_react["default"].createElement(_reactPlayer["default"], {
          className: theme.reactPlayer,
          url: video,
          playing: this.state.playing,
          width: "100%",
          height: "100%",
          controls: controls || this.needsControls
        })));
      }
    }, {
      key: "service",
      get: function get() {
        var video = this.props.video;
        return (0, _utils.getServiceByUrl)(video);
      }
    }, {
      key: "needsControls",
      get: function get() {
        var servicesThatNeedControls = ['dailymotion', 'vimeo'];
        return servicesThatNeedControls.indexOf(this.service) > -1;
      }
    }, {
      key: "wrapperClass",
      get: function get() {
        var theme = this.props.theme;
        return (0, _classnames["default"])(theme.videoThumbnailWrapper, _defineProperty({}, theme.mixcloud, this.service === 'mixcloud'));
      }
    }]);

    return Video;
  }(_react["default"].Component);

  Video.displayName = identifier;
  Video.themeShape = {
    videoThumbnailWrapper: _propTypes["default"].string.isRequired,
    preventDesktop: _propTypes["default"].string.isRequired
  };
  Video.propTypes = {
    video: _propTypes["default"].string.isRequired,
    theme: _propTypes["default"].shape(Video.themeShape).isRequired,
    controls: _propTypes["default"].bool,
    preventDesktopBehaviour: _propTypes["default"].bool
  };
  Video.defaultProps = {
    video: 'https://www.youtube.com/watch?v=NduTgkntfT4',
    controls: false,
    preventDesktopBehaviour: false
  };
  return Video;
};

var _default = factory;
exports["default"] = _default;